import { createAction, props } from '@ngrx/store';
import {
  BrainEstreamComputeRequest,
  BrainEstreamComputeResponse,
} from 'brain-data/model/brain-estream-compute.model';

export const loadEstreamCompute = createAction(
  '[EstreamCompute] load',
  props<{ request: BrainEstreamComputeRequest }>(),
);

export const loadEstreamComputeSuccess = createAction(
  '[EstreamCompute] load success',
  props<{ request: BrainEstreamComputeRequest; response: BrainEstreamComputeResponse }>(),
);

export const loadEstreamComputeError = createAction(
  '[EstreamCompute] load error',
  props<{ request: BrainEstreamComputeRequest; error: Error }>(),
);

export const estreamComputeCacheKey = (request: BrainEstreamComputeRequest): string =>
  `${request.contractNumber.trim()}|${request.billingStart}|${request.billingEnd}`;
